import React, { useRef, useContext } from "react";
import { ScreenSizeContext } from "./context/ScreenSizeContext";
import { ThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import theme from "./theme";
import Navbar from "./components/Navbar";
import { BrowserRouter as Router, Route } from "react-router-dom";
import PrivateRoute from "./hocs/PrivateRoute";
import UnPrivateRoute from "./hocs/UnPrivateRoute";
import Home from "./components/Home";
import ConsultantPage from "./components/ConsultantPage";
import Account from "./components/Account";
import Login from "./components/Login";
import Register from "./components/Register";
import Admin from "./components/Admin";
import VersionManager from "./components/VersionManager";
import VersionEditor from "./components/VersionEditor";
import ConsultantEditor from "./components/ConsultantEditor";
import { SnackbarProvider } from "notistack";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

const useStyles = makeStyles(() => ({
  success: { backgroundColor: "green" },
  error: { backgroundColor: "#FF0000 !important" },
  warning: { backgroundColor: "yellow" },
  info: { backgroundColor: "#13222D !important" },
  text: { color: "white" },
}));

function App() {
  const classes = useStyles();

  const notistackRef = useRef();
  const onClickDismiss = (key) => () => {
    notistackRef.current.closeSnackbar(key);
  };

  const { onMobile } = useContext(ScreenSizeContext);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <SnackbarProvider
        hideIconVariant
        ref={notistackRef}
        action={(key) => (
          <IconButton onClick={onClickDismiss(key)}>
            <CloseIcon className={classes.text} />
          </IconButton>
        )}
        classes={{
          variantSuccess: classes.success,
          variantError: classes.error,
          variantWarning: classes.warning,
          variantInfo: classes.info,
        }}
      >
        <div>
          <Router>
            <Navbar />
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                padding: !onMobile
                  ? "40px 40px 70px 40px"
                  : "20px 20px 70px 20px",
              }}
            >
              <Route exact path="/" component={Home} />
              <PrivateRoute
                path="/consultantpage/:id"
                roles={["admin", "admin/user", "user"]}
                component={ConsultantPage}
              />
              <PrivateRoute
                path="/versionmanager/:id"
                roles={["admin", "admin/user"]}
                component={VersionManager}
              />
              <PrivateRoute
                path="/versioneditor/:id/:versionId"
                roles={["admin", "admin/user"]}
                component={VersionEditor}
              />
              <PrivateRoute
                path="/consultanteditor/:id"
                roles={["admin", "admin/user"]}
                component={ConsultantEditor}
              />
              <UnPrivateRoute path="/login" component={Login} />
              <UnPrivateRoute path="/register/:registrationKey" component={Register} />
              <PrivateRoute
                path="/account"
                roles={["admin", "user", "admin/user", "externaluser"]}
                component={Account}
              />
              <PrivateRoute
                path="/admin"
                roles={["admin", "admin/user"]}
                component={Admin}
              />
            </div>
          </Router>
          <div style={{ display: "flex", justifyContent: "center" }}>
            <div
              style={{
                position: "fixed",
                bottom: "0px",
                textAlign: "center",                
                padding: "10px 15px",
                backgroundColor: "#13222D",
                color: "white",
                borderTopRightRadius: "10px",
                borderTopLeftRadius: "10px",
              }}
            >
              © 2021 Drakryggen | Developed by Drakryggen
            </div>
          </div>
        </div>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;
